import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import checkAgent511Access from '@rsos/utils/checkAgent511Access';
import TextTo911Form from './TextTo911Form';

/**
 * Container component for the TextTo911Form triggered by the app launcher
 * @param {Function} onClose - Callback function for closing the Form
 */
const TextTo911Container = ({ onClose }) => {
  const sinatra = useSelector(state => state.sinatra);
  const psaps = useSelector(state => state.psaps);

  const hasAgent511Access = useCallback(() => {
    return checkAgent511Access(psaps, sinatra);
  }, [psaps, sinatra]);

  if (!hasAgent511Access) {
    return null;
  }
  return <TextTo911Form onClose={onClose} />;
};

export default TextTo911Container;
